module.exports = __webpack_public_path__ + "assets/images/bfa8607ed1691a6eb4e4c45a66b84b85.svg";